import React, { Component } from "react";
import PropTypes from "prop-types";

import { TTP_DASHBOARD_URL, TTP_HOME_URL } from "Config";
import { clearAllCookies } from "Utils";

export function checkAuthentication(component) {
  return class AuthenticatedRoute extends Component {
    static contextTypes = {
      store: PropTypes.object,
      router: PropTypes.object
    };

    componentWillMount() {
      const {
        store,
        router: { route }
      } = this.context;

      const { auth } = store.getState();
      if (!auth || !auth.user) {
        const {
          location: { pathname }
        } = route;

        clearAllCookies(() => {
          const goto = encodeURI(TTP_DASHBOARD_URL + pathname.substr(1));
          window.location.assign(`${TTP_HOME_URL}?goto=${goto}`);
        });
      }
    }

    render() {
      return React.createElement(component, { ...this.props });
    }
  };
}



// WEBPACK FOOTER //
// ./src/router/checkAuthentication.js